import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { isPublicAuthRequest, isRefreshTokenRequest } from './auth-endpoints';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth  = inject(AuthService);

  if (isPublicAuthRequest(req.url) || isRefreshTokenRequest(req.url)) {
    return next(req);
  }

  const token = auth.getAccessToken();

  if (!token) {
    return next(req);
  }

  return next(
    req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }),
  );
};
